import * as uuid from 'uuid';

export class LabelImage {
    constructor(
        public readonly Id: number = parseInt(uuid.v1(), 10),
        public readonly Url: string,
        public readonly IsLoading: boolean = true
    ) { }
}
